import { Component, OnInit, Inject, ViewChild } from '@angular/core';
//import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { List } from 'linqts';
import { timeout } from 'rxjs/operators';
//import { YouTubePlayerModule } from '@angular/youtube-player';

export class InfoData
{
title:string;
content:string;
withX:boolean;
}


@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.css']
})
export class InfoDialogComponent implements OnInit {

  @ViewChild('player') player: any;
  public formBuilder =  new UntypedFormBuilder();
  public deleteForm:UntypedFormGroup;
  public _isVideo: boolean = false;
  safeURL: any;

  constructor(
    public dialogRef: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InfoData){
    

      if(data.content.toLowerCase().indexOf("https://www.youtube.com/") == 0 )
      {  
        
  
        this._isVideo = true;
      }
     }


  ngOnInit() {


  }

    // Autoplay
    onReady() {

      setTimeout(() => {
           
      this.player.playVideo();    
      }, 500);
   
    }

  public confirm()
  {
    
    this.dialogRef.close("OK");
  }

  public onNoClick()
  {
    this.dialogRef.close();
  }

}
